module.exports = __webpack_public_path__ + "img/banner.cadc32e3.jpg";